export default "assets/images/icons/arrow-top-right-cddb2fe5.svg";